import { useCallback, type JSX } from 'react';
import { PortalLogin, type PortalLoginAdapter } from '@procuai/ui';
import { api } from '../api.js';

/**
 * The public supplier sign-in page (D-102). Like the token portal, it lives OUTSIDE the authenticated
 * app shell: the supplier is not a ProcuAI user and sees no navigation. It posts to POST /portal/login,
 * which always returns 204 (non-enumerating): the page shows the same neutral confirmation whether or
 * not the email is on file, and only surfaces an error if the network call itself fails.
 */
export function PortalLoginPage(): JSX.Element {
  const requestLink = useCallback(async (email: string) => {
    await api<void>('/portal/login', { method: 'POST', body: JSON.stringify({ email }) });
  }, []);

  const adapter: PortalLoginAdapter = { requestLink };
  return <PortalLogin adapter={adapter} />;
}
